import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import FeedbackMessage from 'src/app/components/FeedbackMessage';
import { transclusionHide } from 'src/app/redux/actions/transclusion';
import transclusionSaga from 'src/app/redux/sagas/transclusionSaga.json';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import { sendActivationEmail } from 'src/app/redux/actions/registration/registration';
import 'src/app/containers/TransclusionContainer.scss';


const ResetPasswordInvalidToken = ({ onClose, location }) => (
  <FeedbackMessage onClick={ onClose } icon="error" template="error">
    <p>Link do zmiany hasła wygasł.</p>
    <Link title="Resetuj hasło"
            styleName="description__reset-password-again"
            to={ { pathname: '/przypomnij-haslo', search: location.search } }
      >
        Wygeneruj ponownie link do zmiany hasła
    </Link>
  </FeedbackMessage>

);
ResetPasswordInvalidToken.propTypes = {
  onClose: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

const ResetPasswordError = ({ onClose, location }) => (
  <FeedbackMessage onClick={ onClose } icon="error" template="error">
    <p>Próba zmiany hasła nie powiodła się.</p>
    <Link title="Resetuj hasło"
            styleName="description__reset-password-again"
            to={ { pathname: '/przypomnij-haslo', search: location.search } }
      >
        Wygeneruj ponownie link do zmiany hasła
    </Link>
  </FeedbackMessage>
);
ResetPasswordError.propTypes = {
  onClose: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

const ActivationTokenError = ({ onClose, onClick }) => (
  <FeedbackMessage onClick={ onClose } icon="error" template="error">
    <p>
        Nie udało się potwierdzić konta.{' '}
      <button type="button" onClick={ onClick } styleName="description__button-link">
          Wyślij nowy link aktywacyjny i spróbuj ponownie.
      </button>
    </p>
  </FeedbackMessage>
);
ActivationTokenError.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};

class TransclusionContainer extends React.Component {
  componentTypes = transclusionSaga;

  closeTransclusion = () => {
    const { dispatch } = this.props;

    dispatch(transclusionHide());
  };

  resendActivationEmail = () => {
    const { dispatch } = this.props;
    const userId = getWindowSearchParam('userId');

    dispatch(sendActivationEmail(userId));
    dispatch(transclusionHide());
  };

  render() {
    const { typeName } = this.props;
    if (!typeName) {
      return null;
    }

    const { location } = this.props;
    const { closeTransclusion, resendActivationEmail } = this;
    const { resetPasswordError, resetPasswordInvalidToken, activationTokenError } = this.componentTypes;

    const component = {
      [resetPasswordInvalidToken]: () =>
        <ResetPasswordInvalidToken onClose={ closeTransclusion } location={ location } />,
      [resetPasswordError]: () =>
        <ResetPasswordError onClose={ closeTransclusion } location={ location } />,
      [activationTokenError]: () =>
        <ActivationTokenError onClose={ closeTransclusion }
                              onClick={ resendActivationEmail }
                              location={ location }
        />

    }[typeName];

    return component;

  }
}

TransclusionContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  typeName: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  ...state.transclusionReducer
});

export default connect(mapStateToProps)(withRouter(TransclusionContainer));
